module.exports = __webpack_public_path__ + "media/proksee-viewer/images/search-token-72ce9a3db673bffff866ab63544a2e0a.png";